import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
import mdaeNotfy, { NOTIFY_MESSAGE_TYPE } from "../../../../common_components/common_widgets/toast/notify";
import { getDefaultOptions } from "../../../../utils/fetch";
export const DELETE_EXTERNAL_AUDIT = "DELETE_EXTERNAL_AUDIT";

export const service = async (data) => {
  const options: object = {
    url: `/Api/ExternalAudit/DeleteExternalAudit`,
    method: "POST",
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  };

  const response = await callMvcApi(options);
  if (response.isDeleted) {
    mdaeNotfy({ message: (data.auditTitle ?  data.auditTitle:data.title) + " Deleted Succesfully!", messageType: NOTIFY_MESSAGE_TYPE.SUCCESS })
  }
  else{
    mdaeNotfy({ message: "Unable to delete payer audit", messageType: NOTIFY_MESSAGE_TYPE.ERROR })
  }
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(DELETE_EXTERNAL_AUDIT, service, mock);
